import React from "react";
import { Link } from "react-router-dom";

const CONTENT = {
  terms: {
    title: "Terms & Conditions",
    body: [
      "DilConnect is an 18+ private matchmaking service. By using the service you confirm you are 18 years or older.",
      "Each matching entry requires a one-time fee of ₹199. Each new entry requires a new ₹199 payment.",
      "Every paid entry grants a 24-hour matching session during which you may use CONNECT/NEXT actions. Profiles remain private until a mutual CONNECT creates a match.",
      "The 24-hour service promise refers only to active access to the matching system for 24 hours from session start. We make no guarantee of a relationship or a specific match outcome.",
      "You agree not to upload illegal, abusive, sexual, or impersonating content. Violations will result in account suspension or termination without refund.",
      "DilConnect may suspend, reject, or delete accounts that violate these terms or community guidelines.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "We collect only the information necessary to run the matching service: profile fields, photos you upload, payment metadata, and matching actions.",
      "Photos are stored in private access-controlled storage and are only revealed to users with whom you have a mutual match.",
      "We do not sell your personal data. Payment processing is handled by Razorpay; signatures are verified server-side.",
      "You may request account deletion from your dashboard. Financial records required by law may be retained.",
    ],
  },
  refund: {
    title: "Refund & Cancellation Policy",
    body: [
      "The ₹199 entry fee is non-refundable once the 24-hour matching session has started.",
      "If a session fails to start due to a technical error on our side, the equivalent entry will be credited for a new session.",
      "No automatic replacement or refund is issued for not finding a mutual match within 24 hours — a relationship cannot be guaranteed.",
      "Disputes should be raised via the Contact page within 7 days of the transaction.",
    ],
  },
  eighteen: {
    title: "18+ Policy",
    body: [
      "DilConnect is strictly for adults aged 18 or above.",
      "Age is verified server-side from the date of birth you provide. Falsifying age is a violation and results in account termination.",
      "Content involving minors is strictly prohibited and will be reported to authorities.",
    ],
  },
  safety: {
    title: "Community & Safety Guidelines",
    body: [
      "Treat other members with respect. Harassment, hate speech, and spam are not permitted.",
      "Do not share sensitive personal information (bank details, government IDs) with other members.",
      "Report any user who violates these guidelines. Our team reviews all reports.",
      "Blocking a user ends any active connection and prevents future communication.",
    ],
  },
  contact: {
    title: "Contact & Support",
    body: [
      "For account, payment, or safety issues please contact support@dilconnect.com.",
      "For reporting serious safety concerns, use the Report option on any match or email safety@dilconnect.com.",
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  return (
    <div className="min-h-screen bg-dc-gradient p-4">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="font-display text-sm tracking-widest text-purple-200">← DILCONNECT</Link>
        <h1 className="font-display text-3xl font-extrabold mt-3">{c.title}</h1>
        <div className="glass rounded-3xl p-6 mt-4 space-y-3 text-sm text-purple-100/90 leading-relaxed">
          {c.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </div>
  );
}
